import React, { useState } from 'react';
import {
    getFieldValue,
    RichText,
    Text,
    Link,
} from '@sitecore-jss/sitecore-jss-react';
import PropTypes from 'prop-types';
import Image from '@fhs/shared/src/components/Image/Image';
import buildClassNames from 'classnames';
import { COMPONENT_BG_COLOR } from '../../utilities/themeColor';
import useModalTrigger from '../Modal/useModalTrigger';
import Modal from '../Modal';
import Tier from '../Tier';
import Blocks from '../Blocks';
import './Callout.scss';

export const Callout = ({ fields, hdgClassNames, isCtaButton, theme }) => {
    const [modalState, openModal, closeModal] = useModalTrigger();
    const [selectedModalItem, setSelectedModalItem] = useState();
    const isDarkTheme =
        theme === COMPONENT_BG_COLOR.DARK_GRAY ||
        theme === COMPONENT_BG_COLOR.BLUE;

    const linky = (linkObject) => (
        <div className="callout__cta">
            <Link
                className={buildClassNames({
                    'arrow-link': !isCtaButton,
                    'arrow-link--dark-theme': !isCtaButton && isDarkTheme,
                    'btn btn--secondary': isCtaButton && !isDarkTheme,
                    'btn btn--tertiary': isCtaButton && isDarkTheme,
                })}
                field={linkObject}
            />
        </div>
    );

    const linkModal = (items) => {
        const handleModalLinkClick = (event, item) => {
            setSelectedModalItem(item);
            openModal(event.target);
        };

        return (
            <>
                {items.map((item, index) => (
                    <div key={item.id || index} className="callout__cta">
                        <button
                            type="button"
                            onClick={(e) =>
                                handleModalLinkClick(e, item.fields.items[0])
                            }
                            className={buildClassNames('btn', {
                                'btn--secondary': !isDarkTheme,
                                'btn--tertiary': isDarkTheme,
                            })}>
                            {item.fields.heading.value}
                        </button>
                    </div>
                ))}
                {/* TODO: Replace title text with a Dictionary definition or other CMS data */}
                <Modal
                    id={`link-modal-${selectedModalItem?.id}`}
                    title="Link Modal"
                    className="link-modal modal-root--overlay modal-root--light"
                    currentState={modalState}
                    onClose={closeModal}>
                    <Modal.Close />
                    <Tier>
                        <div
                            style={{
                                width:
                                    selectedModalItem?.fields?.image?.value
                                        ?.width,
                                height:
                                    selectedModalItem?.fields?.image?.value
                                        ?.height,
                            }}>
                            <Image
                                src={selectedModalItem?.fields?.image.value.src}
                                alt={selectedModalItem?.fields?.image.value.alt}
                                priority
                                classNames={{
                                    picture: 'h-full',
                                }}
                            />
                        </div>
                        <div className="vr vr--3x" />
                        <div className="modal__title">
                            <Text
                                field={selectedModalItem?.fields?.title}
                                className="hdg hdg--2"
                                tag="h3"
                            />
                        </div>
                        <div className="vr vr--3x" />
                        <div className="modal__body">
                            <RichText
                                className="rich-text"
                                field={selectedModalItem?.fields?.body}
                            />
                        </div>
                        <div className="vr vr--6x" />
                        {selectedModalItem?.fields?.items &&
                            selectedModalItem?.fields?.items?.length > 0 && (
                                <Blocks
                                    hasDivider
                                    count={
                                        selectedModalItem.fields.items.length
                                    }>
                                    {selectedModalItem.fields.items.map(
                                        (item, index) => (
                                            <div
                                                className="blocks__item"
                                                key={item.id || index}>
                                                <Callout
                                                    fields={item.fields}
                                                    hdgClassNames="hdg--3"
                                                    isCtaButton
                                                />
                                            </div>
                                        )
                                    )}
                                </Blocks>
                            )}
                    </Tier>
                </Modal>
            </>
        );
    };

    return (
        <div className="callout">
            <div className="callout__content">
                {getFieldValue(fields, 'title') && (
                    <div className="callout__content__hd">
                        <Text
                            field={fields.title}
                            tag="h2"
                            className={buildClassNames('hdg', hdgClassNames)}
                        />
                    </div>
                )}
                {(getFieldValue(fields, 'bodyContent') ||
                    getFieldValue(fields, 'body')) && (
                    <div className="callout__content__bd">
                        <RichText
                            className={buildClassNames('rich-text', {
                                'rich-text--dark-theme': isDarkTheme,
                            })}
                            field={fields.bodyContent || fields.body}
                        />
                    </div>
                )}
            </div>
            {/* In this instance, a Sitecore "item" should only ever be a modal */}
            {/* The CMS user should be instructed to only add one item/modal */}
            {/* We will display both the modal and the list of links, if both are present. */}
            {fields.items && fields.items.length > 0 && linkModal(fields.items)}
            {/* 9Up Grid component still uses single link data structure */}
            {fields.callToActionLink &&
                fields.callToActionLink.value.href &&
                linky(fields.callToActionLink)}
            {/* N-Up component uses list of links data structure  */}
            {fields.callToActionLinkList && (
                <ul className="vr-array vr-array--4x">
                    {fields.callToActionLinkList.map((item) => (
                        <li key={item.id}>
                            {getFieldValue(item.fields, 'link') &&
                                item.fields.link.value.href &&
                                linky(item.fields.link)}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

Callout.propTypes = {
    hdgClassNames: PropTypes.string.isRequired,
    isCtaButton: PropTypes.bool.isRequired,
    theme: PropTypes.string.isRequired,
};

export default Callout;
